(() => {
  const desktop = window.matchMedia('(min-width: 940px)');
  const initialize = () => {
    document.querySelectorAll('.header-group > [id$="__header"] .site-header.docking-header').forEach((header) => {
      if (header.dataset.swDesktopStickyReady) return;
      const row = header.querySelector('.header-content');
      const navigation = header.querySelector('.docked-navigation-container__inner');
      if (!row || !navigation) return;
      header.dataset.swDesktopStickyReady = 'true';
      const measure = () => {
        if (!desktop.matches || header.classList.contains('docked-header--dock')) return;
        const rowHeight = row.getBoundingClientRect().height;
        const navigationHeight = navigation.getBoundingClientRect().height;
        if (rowHeight > 0) header.style.setProperty('--sw-normal-header-height', rowHeight + 'px');
        if (navigationHeight > 0) header.style.setProperty('--sw-normal-nav-height', navigationHeight + 'px');
      };
      measure();
      const observer = new ResizeObserver(measure);
      observer.observe(row);
      observer.observe(navigation);
      desktop.addEventListener('change', measure);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
